import { useEditor } from '@craftjs/core';

export const useSelectNode = () => {
  const {
    actions: { selectNode },
    query: { node },
  } = useEditor();

  return (nodeId: string) => {
    selectNode(nodeId);
    node(nodeId).get().dom?.scrollIntoView();
  };
};
